// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import MenuPage from './pages/MenuPage';
import ContactPage from './pages/ContactPage';
import ReservationPage from './pages/ReservationPage';
import OperatingHoursPage from './pages/OperatingHoursPage';
import GalleryPage from './pages/GalleryPage';
import TestimonialsPage from './pages/TestimonialsPage';
import LegalPage from './pages/LegalPage';
import NavigationBar from './components/NavigationBar';
import PromotionPage from './pages/PromotionPage';
import RomPackagePage from './pages/RomPackagePage';
import CateringPage from './pages/CateringPage';
import CorporateEventsPage from './pages/CorporateEventsPage';
import BirthdayCelebrationPage from './pages/BirthdayCelebrationPage';


const App = () => {
  return (
    <Router>
      <NavigationBar />
      <div className="page-wrapper">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/reservation" element={<ReservationPage />} />
        <Route path="/hours" element={<OperatingHoursPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/promotion" element={<PromotionPage />} />
        <Route path="/rom-package" element={<RomPackagePage />} />
        <Route path="/catering" element={<CateringPage />} />
        <Route path="/corporate-events" element={<CorporateEventsPage />} />
        <Route path="/birthday-celebration" element={<BirthdayCelebrationPage />} />
      </Routes>
      </div>
    </Router>
  );
};

export default App;
